import { createApp } from "vue"
import { createPinia } from "pinia"

import App from "./App.vue"
import { router } from "./router/index"
import { msalInstance } from "./auth/msalConfig"

import "./styles.css"

async function bootstrap() {
  await msalInstance.initialize()

  // Surface redirect-promise errors visibly instead of swallowing them.
  // Anything that arrives here (state mismatch, code-exchange failure,
  // wrong audience) is the actual reason "nothing happens" after sign-in.
  let redirectErr: unknown = null
  try {
    const resp = await msalInstance.handleRedirectPromise()
    if (resp?.account) {
      msalInstance.setActiveAccount(resp.account)
      console.log("[mc] redirect handled, active account:", resp.account.username)
    }
  } catch (e) {
    redirectErr = e
    console.error("[mc] handleRedirectPromise failed:", e)
  }

  // If we already have an account from a previous tab/session, mark it active.
  const all = msalInstance.getAllAccounts()
  if (all.length && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(all[0])
  }

  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.mount("#app")

  // Surface a banner so the failure is impossible to miss.
  if (redirectErr) {
    const div = document.createElement("div")
    div.style.cssText = "background:#FEE2E2;color:#991B1B;padding:12px 24px;font:14px Inter,system-ui;border-bottom:1px solid #FECACA"
    div.textContent = "Sign-in error: " + String(redirectErr)
    document.body.prepend(div)
  }
}

bootstrap().catch((err) => {
  console.error("Bootstrap failed:", err)
  document.body.innerHTML = `<div style="padding:40px;font-family:system-ui">Bootstrap failed: ${String(err)}</div>`
})
